<template>
  <v-snackbar v-model="messages" :timeout="timeout" app top right text min-width="auto">
    <v-alert class="pa-0, ma-0" text type="success">
      <v-row v-for="(message, index) in messages" :key="index" align="center">
        <v-col> {{ message.message }}</v-col>
      </v-row>
    </v-alert>
  </v-snackbar>
</template>

<!--We override some default stying from snackbar - the content padding en margin caused extra white spacing-->
<style>
.v-snack__content {
  background-color: transparent;
  padding: 0;
}

.v-application--is-ltr .v-snack__action {
  margin-right: 0;
}
</style>

<script lang="ts">
import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import IconButton from '@/components/button/IconButton.vue';
import NotificationService from '@/services/NotificationService';

@Component({
  components: { IconButton },
})
export default class SuccessAlert extends Vue {
  @Inject('notificationService') notificationService: NotificationService;

  private readonly timeout = 3000;

  created() {
    setTimeout(() => {
      this.notificationService.clearSuccessMessages();
    }, this.timeout);
  }

  @Prop() readonly messages!: [];
}
</script>